import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withArrow?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withArrow = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed shadow-md hover:shadow-lg transform hover:-translate-y-0.5';
  const variants = {
    primary: 'bg-orange-500 hover:bg-orange-600 text-white focus:ring-orange-500 border border-transparent',
    secondary: 'bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500 border border-transparent',
    outline: 'bg-white hover:bg-gray-50 text-blue-900 border-2 border-blue-200 hover:border-blue-300 focus:ring-blue-500'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl uppercase tracking-wide'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  const content = <>
      {children}
      {withArrow && <ArrowRight className="ml-2 h-5 w-5" data-id="element-417" />}
    </>;
  if (href) {
    return <a href={href} className={classes} target="_blank" rel="noopener noreferrer" data-id="element-418">
        {content}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-419">
      {content}
    </button>;
}